export const BASE_PATH = process.env.VUE_APP_BASE_URL;//"https://autom8.ai.digitaltradingco.co.uk";
//export const BASE_PATH = "https://localhost:44307";
